import styled from 'styled-components';

export const StyledTableHead = styled.th(({ theme }) => ({
  background: `${theme.colors.bg} !important`,
}));
